export default "__VITE_ASSET__C7QCj5OJ__"